import React from "react";

import Swal from "sweetalert2";
export let Api = React.createContext();

// BUX START Para mejorar la experiencia del usuario, podemos bloquear todo
// cuando sea necesario Api.loading(true) o Api.loading(false);
Api.loading = (bool) => {
  if (bool) {
    Swal.fire({
      title: "Espere por favor...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  } else {
    Swal.close();
  }
};

Api.notify = (cadena = "Listo", tipo = "success") => {
  Swal.fire("Atención", cadena, tipo);
};

Api.dummy = (d) => {
  return true;
};

// BUX END
let host = window.location.host.split(":")[0];

Api.url = "https://" + host + "/api/";
Api.canFetch = true;
if (localStorage.sesion) {
  if (localStorage.sesion !== "undefined") {
    Api.user_profile = JSON.parse(localStorage.sesion);
  }
}

// Api fetch recibe un servicio (url en API de laravel), los parameteros a
// enviar si se necesita (por default esta vacio) y el tipo de llamada (REST.
// Por default esta es get)
Api.fetch = async (service, params, method = "GET") => {
  if (!Api.canFetch) {
    return false;
  }

  if (method === "GET") {
    if (localStorage.nivel_actual) {
      if (service.indexOf("?") > 0) {
        service += "&nivel_actual=" + localStorage.nivel_actual;
      } else {
        service += "?nivel_actual=" + localStorage.nivel_actual;
      }
    }
  } else {
    if (localStorage.nivel_actual) {
      if (!params) {
        params = {};
      }
      params["nivel_actual"] = localStorage.nivel_actual;
    }
  }

  // aqui se construye la respuesta, donde se toma el metodo dado en el fetch
  // (POST,GET, etc), el body/cuerpo (si se envia informacion al api) y los
  // headers

  const response = await fetch(Api.url + service, {
    method: method,
    body: params && JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: "Bearer " + localStorage.token,
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      localStorage.removeItem("token");
      Api.loading(0);
      Api.canFetch = true;
    }

    if (response.status === 401) {
      Api.canFetch = false;

      if (service !== "auth/login") {
        localStorage.removeItem("token");
        Api.canFetch = false;
        Swal.fire({
          title: "Error",
          text: "Tu sesión ha expirado, por favor accede de nuevo.",
          icon: "error",
          showCancelButton: false,
          cancelButtonColor: "green",
          confirmButtonText: "Continuar",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "login";
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Usuario y/o contraseña inválidos.",
          icon: "error",
          showCancelButton: false,
          cancelButtonColor: "green",
          confirmButtonText: "Continuar",
        });

        localStorage.removeItem("token");
        Api.canFetch = true;
        return false;
      }
    }

    if (response.status === 500) {
      Swal.fire({
        title: "Error de conexión a internet.",
        text: "Por favor intente de nuevo su última acción.",
        icon: "error",
        showCancelButton: false,
        cancelButtonColor: "green",
        confirmButtonText: "Continuar",
      });

      Api.canFetch = false;
      return false;
    }

    if (response.status === 422) {
      return response.json();
    } else {
      throw response;
    }
  } else {
    return response.json();
  }
};

Api.xhr = (service, params, callBack) => {
  var https = new XMLHttpRequest();
  var url = Api.url;

  https.open("POST", url + service, true);

  https.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  https.setRequestHeader("accept", "application/json");

  if (Api.auth.token) {
    https.setRequestHeader("Authorization", "Bearer " + Api.auth.token);
  }

  https.onreadystatechange = function () {
    //Call a function when the state changes.

    if (https.status === 401 && https.readyState === 2) {
      if (!Api.auth.avoid.includes(window.location.pathname.split("/")[1])) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return false;
      }
    }

    if (https.readyState === 4 && https.status === 200) {
      callBack(JSON.parse(https.responseText));
    }

    let tplErrors = "";
    if (https.readyState === 4 && https.status === 422) {
      let error = JSON.parse(https.responseText);
      for (let e in error.errors) {
        if (error.errors[e][0] !== undefined) {
          error.errors[e][0] = error.errors[e][0].replace("_", " "); //.replace("id","");
          tplErrors += `<li>${error.errors[e][0]}</li>`;
        }
      }
      Swal.fire({
        title: "Error al procesar",
        html: `<ul style="text-align:left">${tplErrors}</ul>`,
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Continuar",
      });
    }
  };

  let prms = "";
  if (typeof params === "object") {
    for (let name in params) {
      prms += name + "=" + params[name] + "&";
    }
  } else {
    prms = params;
  }

  https.send(prms);
};

Api.crypt = (string) => {};

Api.decrypt = (string) => {};

Api.loadCatalogues = () => {
  if (localStorage.getItem("user") === null) {
    Api.loading(1);
  }

  let version;
  if (localStorage.getItem("cats") !== null) {
    version = Api.loadCatalogue("version");
    if (localStorage.getItem("user") === null) {
      Api.loading(0);
    }
  } else {
    version = 0;
  }
  Api.xhr(
    "cat/getLocalCats",
    {
      version: version,
    },
    (r) => {
      if (r.version === version) {
        //console.log("¡Actualizado!");
        if (localStorage.getItem("user") === null) {
          Api.loading(0);
        }
      } else {
        //console.log("¡Nueva Version!");
        let data = JSON.stringify(r);
        localStorage.cats = data;
        localStorage.version = r.version;
        if (localStorage.getItem("user") === null) {
          Api.loading(0);
        }
      }
    }
  );
};

Api.loadCatalogue = (cat) => {
  if (localStorage.cats) {
    let cats = JSON.parse(localStorage.cats);
    return cats[cat];
  }
};

//OK k pasa...

Api.serialize = (form, obj = false) => {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (
      !field.name ||
      field.disabled ||
      ["file", "reset", "submit", "button"].indexOf(field.type) > -1
    )
      return;
    if (field.type === "select-multiple") {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push(field.name + "=" + option.value);
      });
      return;
    }
    if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
      return;
    arr.push(field.name + "=" + field.value);
  });
  if (obj) {
    return arr.join("&");
  } else {
    let arri = {};
    for (let el in arr) {
      let dti = arr[el].split("=");
      if (dti[1] && dti[1] !== "undefined") {
        arri[dti[0]] = dti[1];
      }
    }
    return arri;
  }
};

Api.form = (obj) => {
  let noDom = false;
  if (!document.querySelector(obj.target)) {
    console.warn(
      "El elemento " + obj.target + ", no es accesible o no existe. API.FORM"
    );
    noDom = true;
  }
  let _form = "";
  if (!noDom) {
    _form = document.querySelector(obj.target);
  } else {
    _form = document.createElement("div");
  }
  let tpl = "";
  let el = "";
  let elements = [];
  for (let ele in obj.elements) {
    for (let eli in obj.elements[ele])
      el = obj.elements[ele][eli] ? obj.elements[ele][eli] : el;
    elements.push(el.name);
  }

  _form.elements = elements;

  for (let ele in obj.elements) {
    //let el = "";
    let eli = "";
    for (eli in obj.elements[ele])
      el = obj.elements[ele][eli] ? obj.elements[ele][eli] : el;
    tpl += `<div class="col-sm-${el.cols}">`;
    let hide = "";
    if (eli !== "fieldset") {
      if (el.type === "hidden") {
        hide = "hide";
      }

      if (!el.label) {
        el.label = "&nbsp;";
      }
      let classHide = "";
      if (el.hide) {
        classHide = "hide";
      }

      tpl += `
        <div class="form-group ${el.name} ${classHide} ${hide}">
        <label class="col-form-label">
        ${el.label}
        </label>`;
    }

    let elem;

    for (let el in obj.elements[ele]) elem = el;

    let readonly = "";
    if (obj.readonly) {
      readonly = "readonly";
    }

    let tag = elem;
    if (elem === "panel") {
      elem = "span";
    }
    tag = elem;

    tpl += `<${elem}   autocomplete="off" `;

    let classes = "";

    if (obj.elements[ele][eli] && obj.elements[ele][eli].class) {
      classes = obj.elements[ele][eli].class;
    } else {
      classes = obj.elementClass;
    }

    for (let eli in obj.elements[ele]) {
      if (!obj.elements[ele][eli]) break;
      tpl += ` class="${classes}"id="${obj.elements[ele][eli]["name"]}" name="${obj.elements[ele][eli]["name"]}"`;

      for (let param in obj.elements[ele][eli]) {
        if (obj.disabled === true) {
          param = "disabled";

          if (param === "disabled" && obj.elements[ele][eli][param] === false) {
            param = "";
          }
        } else {
          if (param === "disabled" && obj.elements[ele][eli][param] === true) {
            param = "disabled";
          } else {
            //param = "";
          }
        }

        if (obj.elements[ele][eli][param] !== undefined) {
          tpl += `  ${param}="${obj.elements[ele][eli][param]}"  `;
        }
      }
    }

    if (elem === "select" || elem === "textarea" || elem === "button") {
      if (elem === "button") {
        tpl += `    ><i class="${el.icon}"></i> ${el.text}</${elem}></div></div>`;
      } else {
        tpl += `  ></${elem}></div></div>`;
      }
    } else {
      if (elem === "fieldset") {
        tpl += `   ><legend class="${classes}">${el.label}</legend>
                ${el.content}
                </${elem}></div></div>`;
      } else {
        tpl += " /></div></div>";
      }
    }
  }

  _form.innerHTML = `<form id="${obj.name}"  onsubmit="return false;" class="row ${obj.class}">${tpl}</form>`;
  _form.obj = obj;

  var elm;
  var x;
  var lclick = {};
  for (let e in obj.elements) {
    elm = obj.elements[e];
    for (x in elm);

    if (elm[x] && elm[x].click) {
      lclick = elm[x].click;
      _form.querySelector("#" + elm[x].name)._form = _form;
      _form.querySelector("#" + elm[x].name).addEventListener("click", lclick);
    }
  }

  //** Elements renders */ let el;
  for (let ele in obj.elements) {
    for (let eli in obj.elements[ele]) {
      if (!obj.elements[ele][eli]) break;
      el = obj.elements[ele][eli];
      let elo = _form.querySelector("#" + el.name);
      if (el.render) {
        elo.setContent = (legend, content) => {
          if (!content) {
            content = legend;
            legend = "";
          }
          elo.innerHTML =
            `<legend class="${elo.classList}">${legend}</legend>` + content;
        };
        el.render(elo);
      }
      if (el.onchange) {
        elo.addEventListener("change", el.onchange);
      }
    }
  }
  /*** fin */

  if (obj.render) {
    _form.data = Api.serialize(_form.querySelector("form"));
    obj.render(_form);
  }

  if (obj.onchange) {
    _form.addEventListener("change", (e) => {
      let data = Api.serialize(_form.querySelector("form"));
      let serial = Api.serialize(_form.querySelector("form"), 1);
      _form.obj.onchange(e.target, data, serial);
    });
    _form.addEventListener("keyup", (e) => {
      let data = Api.serialize(_form.querySelector("form"));
      let serial = Api.serialize(_form.querySelector("form"), 1);
      _form.obj.onchange(e.target, data, serial);
    });
  }

  _form.clear = () => {
    for (let e in _form.elements) {
      _form.querySelector("#" + _form.elements[e]).value = "";
    }
  };

  _form.merge = (data) => {
    for (let field in data) {
      if ((obj = _form.querySelector("#" + field))) {
        if (obj.type === "datetime-local") {
          let isoDate = new Date(data[field]).toISOString();
          _form.querySelector("#" + field).value = isoDate.substring(0, 19);
        } else {
          _form.querySelector("#" + field).value = data[field];
        }
      }
    }
  };
  _form.data = () => {
    return Api.serialize(_form.querySelector("form"));
  };

  _form.serial = () => {
    return Api.serialize(_form.querySelector("form"), 1);
  };

  _form.html = () => {
    return _form.innerHTML;
  };

  _form.hide = (_array) => {
    if (typeof _array === "string") {
      _form.querySelector("." + _array).classList =
        _form.querySelector("." + _array).classList + " hide";
    }

    if (typeof _array === "object") {
      _array.forEach((o) => {
        if (_form.querySelector("." + o)) {
          _form.querySelector("." + o).classList =
            _form.querySelector("." + o).classList + " hide";
        }
      });
    }
  };

  _form.show = (_array) => {
    if (typeof _array === "string") {
      _form.querySelector("." + _array).classList = _form
        .querySelector("." + _array)
        .classList.replace("hide", "");
    }

    if (typeof _array === "object") {
      _array.forEach((o) => {
        if (_form.querySelector("." + o)) {
          _form.querySelector("." + o).classList = _form
            .querySelector("." + o)
            .classList.replace("hide", "");
        }
      });
    }
  };

  return _form;
};

Api.show = (elm) => {
  let el = document.querySelector(elm);
};

/* API MODAL */
Api.modal = (obj) => {
  let tpl = `
    <div tabindex="-1" id="tpl" style="position: relative; z-index: 1050; display: block;">
        <div class="">
            <div class="modal modal-message fade show" role="dialog" tabindex="-1" style="display: block;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">${obj.title}</h5><button type="button" class="close" aria-label="Close"><span aria-hidden="true">×</span></button></div>
                        <div class="modal-body  ${obj.class}" id="body"></div>
                        </div></div></div>

                        <div class="modal-backdrop fade show"></div></div></div>`;

  var myDiv = document.createElement("div");
  myDiv.id = "div_id";
  myDiv.innerHTML = tpl;
  myDiv.addEventListener("keyup", (e) => {
    if (e.key === "Escape") {
      myDiv.querySelector("#tpl").style.display = "none";
      document.querySelector("body").classList = "";
    }
  });
  myDiv.querySelector(".close").addEventListener("click", (e) => {
    myDiv.querySelector("#tpl").style.display = "none";
    document.querySelector("body").classList = "";
  });
  document.querySelector("body").classList = "modal-open";
  if (typeof obj.html !== "object") {
    myDiv.querySelector("#body").innerHTML = obj.html;
  } else {
    myDiv.querySelector("#body").appendChild(obj.html);
  }
  document.body.appendChild(myDiv);

  myDiv.close = (e) => {
    myDiv.querySelector(".close").click();
  };

  return myDiv;
};
///////////////

Api.grid = (obj) => {
  let _page = 1;
  let _grid = document.querySelector(obj.target);
  let _total = 0;
  let _showing = 5;
  if (obj.rowsPerPage) {
    _showing = obj.rowsPerPage[0];
  }
  let _sortCol = "";
  let _sortDirection = "";
  let _headerIsRendered = false;
  let _lastSearch = "";

  if (obj.titulo === undefined || obj.titulo === "") {
    obj.titulo = "";
  } else {
    obj.titulo = "<span style=padding:4px;>" + obj.titulo + "</span>";
  }
  _grid.innerHTML = `
     <div style="overflow-x:auto;overflow-y:hidden;margin-bottom:10px;height:100%">
       <div style="width:100%;color:white;background:rgba(255,255,255,.1)">
        ${obj.titulo}
        </div>
       <table id="tblcontrol" class="${obj.tableClass} blur" style="width:100%;">
       <thead></thead>
       <tbody></tbody>
       </table>
       </div>
       <div  id="pager">
       <div id="progress" style="position: absolute;
       left      : 0;
       width     : 100%;
       z-index   : 1;
       color     : white;
       text-align:center">
       <div style="height:14px;text-transform:uppercase;font-weight:bolder;border-radius:3px;top:-18px;left:calc(50% - 45%);width:90%;position:absolute;font-size:10px" class="progress-bar bg-warning progress-bar-striped progress-bar-animated">${obj.progressText}</div></div>
       
       <div class="d-flex align-items-center justify-content-center" >
       <div class="ml-3 mr-1">Mostrar:
       </div>
       <div class="width-80 mx-4">
          <select class="form-control" id="rpaginas">
          </select>
       </div>
       <ul class="pagination mb-0">
           <li class="page-item" id="first">
           <button
                   class="page-link" >
               <i class="fa fa-angle-double-left">
               </i>
           </button>
           </li>
           <li class="page-item" id="prev">
           <button class="page-link">
               <i class="fa fa-angle-left">
               </i>
           </button>
           </li>
           <li class="page-item d-flex align-items-center px-2">
           <div>Página 
               <strong> 
                   <span id="pagina">0</span> de <span id="paginas">0</span>
               </strong>
           </div>
           </li>
           <li class="page-item" id="next">
           <button  class="page-link">
               <i class="fa fa-angle-right">
               </i>
           </button>
           </li>
           <li class="page-item" id="last">
           <button class="page-link">
               <i class="fa fa-angle-double-right">
               </i>
           </button>
           </li>
       </ul>
       <div class="ml-3 mr-1">Página:
       </div>
       <div class="width-80 mx-4">
          <select class="form-control" id="spaginas">
          </select>
       </div>
       <div></div></div>`;

  _grid.go = (page = 1, search = "") => {
    if (page === 0) {
      if (_grid.paginaActual) {
        page = _grid.paginaActual;
      } else {
        page = 1;
      }
    } else {
      _grid.paginaActual = page;
    }

    if (search !== "") {
      _lastSearch = search;
    } else {
      _lastSearch = "";
    }

    if (!page) {
      _page = 1;
      return;
    }

    if (_total > 0 && page >= _total) {
      //    return;
    }

    _grid.querySelector("#progress").classList = "";

    _grid.querySelector("#tblcontrol").classList = obj.tableClass + " blur";
    Api.fetch(
      obj.source +
        "?page=" +
        page +
        "&rowsPerPage=" +
        _showing +
        "&sortDir=" +
        _sortDirection +
        "&sort=" +
        _sortCol +
        "&" +
        _lastSearch
    ).then((recordSet) => {
      _grid.querySelector("#progress").classList = "hide";
      if (!recordSet) {
        console.warn(
          "Esta acción no puede ser ejecutada, verifique el servicio " +
            obj.source
        );
        return false;
      }

      if (!recordSet.data.length) {
        if (obj.hideonempty) {
          _grid.remove();
          return;
        }
      }

      if (page > recordSet.last_page) {
        _page = recordSet.last_page;
        return;
      }

      _grid.querySelector("#pagina").innerText = recordSet.current_page;
      _grid.querySelector("#paginas").innerText = recordSet.last_page;

      let data = recordSet.data;

      let cols = data[0];
      let th = "";

      if (!_headerIsRendered) {
        let tr = `<tr></tr>`;
        _grid.querySelector("thead").innerHTML = tr;
      }

      // Si especificamos que columnas mostrar entonces...
      if (_headerIsRendered === false) {
        if (obj.rows) {
          for (let tcol in obj.rows) {
            for (let col in cols) {
              if (col !== "id" && col !== "row_num") {
                if (tcol === col) {
                  th += `<th style="width:${
                    obj.rows[tcol].width
                  }" id="sort-${col}">${obj.rows[
                    tcol
                  ].label.toUpperCase()}</th>`;
                }
              }
            }
          }

          if (obj.buttons) {
            th += `<th style="width:${obj.buttonArea}"></th>`;
          }

          _grid.querySelector("tr").innerHTML = th;
          _headerIsRendered = true;
        } else {
          // Si no especificamos las columnas las tomo del arreglo de datos

          for (let col in cols) {
            if (col !== "id" && col !== "row_num") {
              th += `<th id="sort-${col}"  >${col
                .replace("_", " ")
                .toUpperCase()}</th>`;
            }
          }

          if (obj.buttons) {
            th += `<th style="width:${obj.buttonArea}"></th>`;
          }

          _grid.querySelector("tr").innerHTML = th;
          _headerIsRendered = true;
        }

        /* sort */

        if (obj.rows) {
          for (let col in obj.rows) {
            if (col !== "id" && col !== "row_num") {
              let colsort = {};
              colsort = _grid.querySelector("#sort-" + col);

              if (!colsort) {
                break;
              }
              colsort.addEventListener("click", (e) => {
                for (let col in obj.rows) {
                  if (col !== "id" && col !== "row_num") {
                    let scol = _grid.querySelector("#sort-" + col);
                    scol.innerText = obj.rows[col].label.toUpperCase();
                  }
                }

                let colName = obj.rows[col].label.toUpperCase();

                _sortCol = col;

                if (_sortDirection === "desc") {
                  e.target.innerText = "↓" + colName;
                  _sortDirection = "asc";
                } else {
                  e.target.innerText = "↑" + colName;
                  _sortDirection = "desc";
                }

                _grid.go(_page);
              });
            }
          }
        } else {
          for (let col in obj.rows) {
            if (col !== "id" && col !== "row_num") {
              _grid
                .querySelector("#sort-" + col)
                .addEventListener("click", (e) => {
                  for (let col in cols) {
                    if (col !== "id" && col !== "row_num") {
                      let scol = _grid.querySelector("#sort-" + col);
                      scol.innerText = col.replace("_", " ").toUpperCase();
                    }
                  }

                  let colName = col.replace("_", " ").toUpperCase();

                  _sortCol = col;

                  if (_sortDirection === "desc") {
                    e.target.innerText = "↓" + colName;
                    _sortDirection = "asc";
                  } else {
                    e.target.innerText = "↑" + colName;
                    _sortDirection = "desc";
                  }

                  _grid.go(_page);
                });
            }
          }
        }
      }
      /*  termina sort   */

      let tr = "";
      let td = "";
      for (let row in data) {
        td = "";
        if (obj.rows) {
          for (let col in obj.rows) {
            if (col !== "id" && col !== "row_num") {
              td += `<td class="${col}">${data[row][col]}</td>`;
            }
          }
        } else {
          for (let col in data[row]) {
            if (col !== "id" && col !== "row_num") {
              td += `<td>${data[row][col]}</td>`;
            }
          }
        }

        let botones = "";

        if (obj.buttons) {
          for (let button in obj.buttons) {
            if (!obj.buttons[button].name) {
              obj.buttons[button]._name = Math.random()
                .toString(16)
                .substr(2, 4);
              obj.buttons[button].name = "";
            } else {
              obj.buttons[button]._name = obj.buttons[button].name;
            }

            let btn = obj.buttons[button];

            botones += `
                       <button id="b${data[row].id + button}" class="${
              btn.btnClass
            }">
                           <i class="${
                             btn.iconClass
                           }"></i> ${btn.name.toUpperCase()}
                       </button>
                       `;
          }

          td += `<td  class = "${obj.buttonAreaClasses}"style="text-align:center"><div class="btn-group">${botones}</div></td>`;
        }

        tr += `<tr id="i${data[row].id}">${td}</tr>`;
      }

      if (!recordSet.data.length) {
        if (obj.noResults === undefined) {
          tr =
            "<tr><td align='center' colspan=" +
            (Object.keys(obj.rows).length + 1) +
            ">No hay datos</td></tr>";
        } else {
          tr = "<tr><td align='center'>" + obj.noResults + "</td></tr>";
        }
      }
      _grid.querySelector("tbody").innerHTML = tr;

      /* Columnas personalizadas */
      for (let row in data) {
        if (obj.rows) {
          for (let col in obj.rows) {
            if (obj.rows[col] && obj.rows[col].render) {
              let me = _grid.querySelector(
                "tr#i" + data[row]["id"] + ">td." + col
              );
              me.data = data[row];
              me.id = col;
              obj.rows[col].render(me);
            }
          }
        }
      }

      /*   */

      /*buttons event */
      if (obj.buttons) {
        for (let row in data) {
          for (let button in obj.buttons) {
            let btn = obj.buttons[button];
            let __btn = _grid.querySelector("#b" + data[row].id + button);
            __btn.addEventListener("click", (e) => {
              btn.btnClick(data[row]);
            });
            try {
              btn.render(__btn, data[row]);
            } catch (e) {}
          }
        }
      }
      /*  */

      let trs = _grid.querySelectorAll("tbody tr");
      for (tr in trs) {
        if (trs[tr].id) {
          trs[tr].data = data[tr];
          trs[tr].addEventListener(
            "click",
            (e) => {
              if (e.target.parentElement.data) {
                let _trs = _grid.querySelectorAll("tbody tr.active");

                for (let __trs in _trs) {
                  if (_trs[__trs]) {
                    if (!isNaN(__trs)) {
                      _trs[__trs].classList = "inactive";
                    }
                  }
                }
                e.target.parentElement.classList = "active";
                if (obj.rowClick) {
                  obj.rowClick(e.target.parentElement.data);
                }
              }
            },
            true
          );
        }
      }

      let options = "";
      let selected = "";

      _total = recordSet.last_page;

      for (let x = 1; x <= recordSet.last_page; x++) {
        if (x === recordSet.current_page) {
          selected = "selected";
        } else {
          selected = "";
        }
        options += `<option style="background:black;color:white" ${selected} value=${x}>${x}</option>`;
      }
      _grid.querySelector("#spaginas").innerHTML = options;
      _grid.querySelector("#tblcontrol").classList = obj.tableClass;
    });
  };

  let options;
  for (let showing in obj.rowsPerPage) {
    options += `<option style="background:black;color:white" value=${obj.rowsPerPage[showing]}>${obj.rowsPerPage[showing]}</option>`;
  }

  if (obj.hidePager) {
    let pager = _grid.querySelector("div#pager");
    pager.style.display = "none";
  }
  _grid.querySelector("#rpaginas").innerHTML = options;
  _grid.querySelector("#rpaginas").addEventListener("change", (e) => {
    _showing = e.srcElement.value;
    _grid.go(_page);
  });

  _grid.querySelector("#first").addEventListener("click", (e) => {
    _page = 1;
    _grid.go(_page);
  });

  _grid.querySelector("#last").addEventListener("click", (e) => {
    _grid.go(_total);
  });

  _grid.querySelector("#next").addEventListener("click", (e) => {
    if (_total > _page) {
      _page++;
    }
    _grid.go(_page);
  });

  _grid.querySelector("#prev").addEventListener("click", (e) => {
    _page--;
    _grid.go(_page);
  });

  _grid.querySelector("#spaginas").addEventListener("change", (e) => {
    _grid.go(e.srcElement.value);
  });

  _grid.go(_page);

  return _grid;
};

Api.auth = {
  token: localStorage.token,
  avoid: [
    "login",
    "register",
    "confirm",
    "confirmed",
    "password-request",
    "password-reset",
  ],
  setToken: (token) => {
    localStorage.token = token;
    Api.auth.token = token;
  },
  check: () => {
    if (!Api.auth.token) {
      if (!Api.auth.avoid.includes(window.location.pathname.split("/")[1])) {
        window.location.href = "/login";
      }
    } else {
      Api.auth.profile(function (response) {
        if (!Api.auth.avoid.includes(window.location.pathname.split("/")[1])) {
          if (!response.email_verified_at) {
            Api.user_profile = response;
            localStorage.sesion = JSON.stringify(response);
            window.location.href = "/confirm";
          }
        }
      });
    }
  },
  login: (frmData, callBack) => {
    Api.xhr("auth/login", frmData, (response) => {
      callBack(response);
    });
  },
  logout: () => {
    Api.xhr("auth/logout", null, (r) => {
      localStorage.removeItem("token");
      window.location.href = "/login";
    });
  },
  profile: (callBack) => {
    if (!Api.auth.avoid.includes(window.location.pathname.split("/")[1])) {
      Api.xhr("auth/profile", null, (r) => {
        callBack(r);
      });
    }
  },
};

Api.upload = (obj) => {
  let target = document.querySelector(obj.target);
  let tpl = document.createElement("div");

  let required = `<ul>`;
  let options = `<option value="">Seleccione un documento a cargar</option>`;
  let carga = [];
  let dataOK = 0;
  if (obj.ok) {
    dataOK = Object.keys(obj.ok).length;
  }

  let obligatoriosCargados = dataOK;
  // let obligatoriosCargados = Object.keys(obj.ok).length || 0;
  // let cargados = Object.keys(obj.ok).length || 0;
  let cargados = dataOK;

  // contamos los documentos requeridos
  let docsRequeridos =
    Object.keys(obj.required.filter((el) => el.obligatorio === "1")).length ||
    0;
  let documentosTotales = Object.keys(obj.required).length || 0;

  for (let req in obj.required) {
    let desc = obj.required[req].descripcion,
      obligatorio = obj.required[req].obligatorio,
      entregaOrginal = obj.required[req].entrega_original,
      tipoDocumento = "";

    // asignamos un color rojo al texto depediendo si es obligatorio
    if (obligatorio === "1") {
      tipoDocumento += "🔴";
    }

    // asignamos un color verde al texto depediendo si es documento de entrega original
    if (entregaOrginal === "1") {
      tipoDocumento += "🟢";
    }

    if (obj.required[req].actividad) {
      desc = desc.replace(
        "**ACTIVIDAD**",
        "<b>" + obj.required[req].actividad + "</b>"
      );
    }

    required += `<li id="li-${obj.required[req].id}"> ${desc} ${tipoDocumento}</li>`;
    options += `<option id="o-${obj.required[req].id}" data-obligatorio="${obligatorio}" value="${obj.required[req].id}">${desc}</option>`;
  }
  required += `</ul>`;
  tpl.innerHTML = `
            <h4>Adjuntar documentación requerida (<span id='cargados'>0</span> de <span id='reqs'>${docsRequeridos}</span>):</h4>
            <hr />
            <h6>*Los tipos extensión de los documentos que se admiten son: ${
              obj.exts
            }</h6>
            <h6>*🔴 Documento obligatorio</h6>
            <h6>*🟢 Documento de entrega original</h6>
            <hr />
            ${required}<hr />
            <div class="form-group row col-md-12">
                <label class=" col-md-8" id="fileup">
                    <select id="documento_id" class="form-control m-b-5">
                    ${options}
                    </select>
                </label>
                <div class="col-md-4" id="ctlcarga">
                    <div  id="btncarga" style="width:100%" class="btn btn-primary">Cargar Documento
                    </div>
                    <input id="cargafile" type="file" accept="${obj.exts.replace(
                      " ",
                      ""
                    )}" style="display: none;">
                </div>
                <div class="hide" style="width:100%" id="btncargar">
                    <btn  id="inicarga"  class="btn btn-success btn-block">Iniciar Carga</btn>
                </div>

              </div>
            `;

  target.innerHTML = tpl.innerHTML;

  for (let ok in obj.ok) {
    try {
      target.querySelector("#o-" + obj.ok[ok].tipo_documento_id).remove();
      target.querySelector("#li-" + obj.ok[ok].tipo_documento_id).classList =
        "markfile";
    } catch (e) {}
  }
  target.querySelector("#cargados").innerText =
    target.querySelectorAll(".markfile").length;

  target.querySelector("#btncarga").addEventListener("click", (c) => {
    if (target.querySelector("#documento_id").value === "") {
      Swal.fire({
        title: "Atención",
        text: "Por favor seleccione tipo de documento a cargar primero.",
      });
      return;
    }

    target.querySelector("#cargafile").click();
  });

  target.querySelector("#inicarga").addEventListener("click", (c) => {
    Api.loading(1);

    Api.fetch(obj.post, { data: carga, params: obj.params }, "POST").then(
      (r) => {
        Api.loading(0);
        if (obj.onFinish) {
          obj.onFinish(r);
        }
      }
    );
  });

  target.querySelector("#cargafile").addEventListener("change", (c) => {
    var file = c.target.files[0];
    var duplicado = false;
    for (let docu in carga) {
      if (carga[docu].archivo === file.name) {
        duplicado = true;
        Swal.fire({
          title: "Error",
          text: `El documento ${file.name} ya se ha cargado por favor seleccione otro.`,
          icon: "error",
          confirmButtonText: "Continuar",
        });
      }
    }

    target.querySelector("#cargafile").value = "";

    if (duplicado) {
      return;
    }

    var reader = new FileReader();
    let data = {
      id: obj.params.id,
      solicitud_id: obj.params.solicitud_id,
      actividad_id: obj.params.actividad_id,
      archivo: file.name,
      tipo_documento: target.querySelector("#documento_id").value,
    };
    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.data = reader.result;
        carga.push(data);

        target.querySelector(
          "#li-" + target.querySelector("#documento_id").value
        ).classList = "markfile";

        // let tcarga = target.querySelectorAll(".markfile").length;

        // target.querySelector("#cargados").innerHTML = tcarga;

        let docuTarget = target.querySelector("#documento_id").options;
        let docuObligatorio =
          docuTarget[docuTarget.selectedIndex].dataset.obligatorio;

        if (docuObligatorio === "1") {
          obligatoriosCargados += 1;

          target.querySelector("#cargados").innerHTML = obligatoriosCargados;
        }

        cargados += 1;

        // verificamos si los documentos que son requeridos estan cargados para mostrar el boton de carga
        if (obligatoriosCargados === docsRequeridos) {
          target.querySelector("#ctlcarga").className = "col-md-2";
          target.querySelector("#btncargar").className = "col-md-2";
        }

        // escondemos el select y el boton de carga cuando todos los documentos estén cargados
        if (documentosTotales === cargados) {
          target.querySelector("#ctlcarga").classList = "hide";
          target.querySelector("#fileup").classList = "hide";
          target.querySelector("#btncargar").className = "col-md-12";
          target.querySelector("#inicarga").classList.remove("btn-block");
          target.querySelector("#inicarga").classList.add("pull-right");
        }

        target
          .querySelector("#o-" + target.querySelector("#documento_id").value)
          .remove();
      };
    }
  });

  return target;
};

Api.auth.check();
